import React from 'react';
export const HeroSection = () => {
  return <section className="relative w-full min-h-screen flex flex-col items-center justify-center px-4 py-16 overflow-hidden" data-id="element-114">
      <div className="absolute inset-0 z-0" data-id="element-115">
        <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAZAoodXCkladHLJ5FjZzDPQ8Y1bI7cAXhNmu0" alt="Kobieta w łóżku z książką" className="w-full h-full object-cover opacity-40" data-id="element-116" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 to-black/95" data-id="element-117"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-118">
        <div className="text-gray-400 text-sm mb-6 font-mono animate-pulse" data-id="element-119">
          2:34 nad ranem...
        </div>
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-6 leading-tight tracking-tight" data-id="element-120">
          ŁZY W OCZACH MĘŻA PO 18 LATACH ZIMNEJ WOJNY
        </h1>
        <h2 className="text-2xl md:text-4xl font-script text-red-500 italic mb-10" data-id="element-121">
          ...i to wszystko zmieniła jedna mała zmiana
        </h2>
        <div className="mt-12" data-id="element-122">
          <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAZAoodXCkladHLJ5FjZzDPQ8Y1bI7cAXhNmu0" alt="Kobieta w łóżku z książką" className="w-full max-w-2xl mx-auto rounded-lg shadow-2xl" data-id="element-123" />
        </div>
      </div>
      <div className="absolute bottom-10 left-0 right-0 flex justify-center" data-id="element-124">
        <div className="animate-bounce text-center" data-id="element-125">
          <svg className="w-6 h-6 text-white mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-126">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-127"></path>
          </svg>
          <p className="text-white text-xs mt-2" data-id="element-128">
            ↓ POZNAJ CAŁĄ HISTORIĘ MAGDY ↓
          </p>
        </div>
      </div>
    </section>;
};